<template lang="pug" src="./blog-lists.pug"></template>

<script>
export default {
  computed: {
    props () {
      return this.$store.state.blog
    }
  },
  data () {
    return {
      pages: 3,
      posts: false
    }
  },
  async mounted () {
    this.props ? this.posts = true : ''
  }
}
</script>



// WEBPACK FOOTER //
// blog-lists.vue?64ebef5c